// extracted by mini-css-extract-plugin
export default {"sectionContent":"style_sectionContent__h0rpj","tableParent":"style_tableParent__P7DoN"};